module.exports = __webpack_public_path__ + "static/author-2a7c92e151a5c2dc3601fae0ba7043d8.png";